import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 充值记录分页查询
 * @param meterIds
 * @param startTime
 * @param endTime
 * @param limit
 * @param offset
 * @param rechargeChannel
 * @param rechargeType
 * @param status
 */
export function rechargeRecordByPage(meterIds,startTime,endTime,limit,offset,rechargeChannel,rechargeType,status) {
  return request({
    url: cmsServerContext + '/RechargeRecord/rechargeRecordByPage',
    method: 'post',
    data:{meterIds:meterIds,startTime:startTime,endTime:endTime,limit:limit,offset:offset,rechargeChannel:rechargeChannel,rechargeType:rechargeType,status:status}
  })
}

/**
 * 查询所有充值类型
 */
export function selectRechargeType() {
  return request({
    url: cmsServerContext + '/RechargeRecord/rechargeType',
    method: 'get'
  })
}

/**
 * 查询所有充值渠道
 */
export function selectRechargeChannel() {
  return request({
    url: cmsServerContext + '/RechargeRecord/rechargeChannel',
    method: 'get'
  })
}

/**
 * 查询累计充值次数
 * @param meterIds
 * @param startTime
 * @param endTime
 * @param status
 */
export function totalRechargeCount(meterIds,startTime,endTime,rechargeChannel,rechargeType,status) {
  return request({
    url: cmsServerContext + '/RechargeRecord/totalRechargeCount',
    method: 'post',
    data:{meterIds:meterIds,startTime:startTime,endTime:endTime,rechargeChannel:rechargeChannel,rechargeType:rechargeType,status:status}
  })
}

/**
 * 查询累计充值金额
 * @param meterIds
 * @param startTime
 * @param endTime
 * @param status
 */
export function totalRecharge(meterIds,startTime,endTime,rechargeChannel,rechargeType,status) {
  return request({
    url: cmsServerContext + '/RechargeRecord/totalRecharge',
    method: 'post',
    data:{meterIds:meterIds,startTime:startTime,endTime:endTime,rechargeChannel:rechargeChannel,rechargeType:rechargeType,status:status}
  })
}

/**
 * 查询累计实际到账
 * @param meterIds
 * @param startTime
 * @param endTime
 * @param status
 */
export function totalRealAmount(meterIds,startTime,endTime,rechargeChannel,rechargeType,status) {
  return request({
    url: cmsServerContext + '/RechargeRecord/totalRealAmount',
    method: 'post',
    data:{meterIds:meterIds,startTime:startTime,endTime:endTime,rechargeChannel:rechargeChannel,rechargeType:rechargeType,status:status}
  })
}

/**
 * 快捷充值&费用充抵
 * @param tradeNo
 * @param commandId
 * @param meterId
 * @param totalAmount
 * @param rechargeType
 * @param rechargeChannel
 * @param customerId
 * @param customerUserId
 * @param userId
 */
export function quickRecharge(tradeNo,commandId,meterId,totalAmount,rechargeType,rechargeChannel,customerId,customerUserId,userId) {
  return request({
    url: cmsServerContext + '/RechargeRecord/quickRecharge',
    method: 'post',
    data:{tradeNo:tradeNo,commandId:commandId,meterId:meterId,totalAmount:totalAmount,customerId:customerId,customerUserId:customerUserId,rechargeType:rechargeType,rechargeChannel:rechargeChannel,userId:userId}
  })
}

/**
 * 重新充值
 * @param tradeNo 订单号
 * @param commandId 命令uuid
 * @param operationId 操作人id
 */
export function againRecharge(tradeNo,commandId,operationId) {
  return request({
    url: cmsServerContext + '/RechargeRecord/againRecharge',
    method: 'post',
    data:{tradeNo:tradeNo,commandId:commandId,operationId:operationId}
  })
}